import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import type { BuddyMatchItem } from '@wlb/shared/types/match';
import { useTranslation } from '@wlb/shared/i18n/useTranslation';
import { AuthFlowLayout } from '../components/layout/AuthFlowLayout';
import { BrandLogo } from '../components/ui/BrandLogo';
import { Button } from '../components/ui/Button';
import './matchOnboarding.css';

type MatchLocationState = { matches?: BuddyMatchItem[] };

function MatchAvatar({ name, url }: { name: string; url?: string }) {
  const [failed, setFailed] = useState(false);
  if (!url || failed) {
    return <span className="match-onboarding__avatar" aria-hidden>{name.slice(0, 1)}</span>;
  }
  return <img src={url} alt="" onError={() => setFailed(true)} />;
}

export function MatchResults() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state } = useLocation();
  const matches = (state as MatchLocationState | null)?.matches ?? [];

  return (
    <AuthFlowLayout>
      <section className="match-onboarding match-onboarding--results">
        <button className="auth-flow__back" type="button" onClick={() => navigate('/survey/q9')} aria-label={t('matchOnboarding.backToSurvey')}>‹</button>
        <div className="match-onboarding__illustration match-onboarding__illustration--celebrate" aria-hidden><BrandLogo compact /></div>
        <h1>{t('matchOnboarding.resultsTitle')}</h1>
        <p>{t('matchOnboarding.resultsSubtitle')}</p>
        {matches.length ? (
          <ul className="match-onboarding__results" aria-label={t('matchOnboarding.matchListLabel')}>
            {matches.map((match) => <li key={match.id} className="match-onboarding__result">
              <MatchAvatar name={match.name} url={match.profilePictureUrl} />
              <span><strong>{match.name}</strong><small>{match.tag}</small></span>
              <b>{t('common.matchPercent', { percent: match.score })}</b>
            </li>)}
          </ul>
        ) : <div className="match-onboarding__empty" role="status">{t('common.noMatchesFound')}</div>}
        <Button fullWidth size="lg" onClick={() => navigate('/onboarding/ai-buddy')}>{t('common.buttons.continue')}</Button>
      </section>
    </AuthFlowLayout>
  );
}
